export enum Unit {
  GRAM = 'g',
  KILOGRAM = 'kg',
  TON = 't',
  MILLILITER = 'ml',
  LITER = 'l',
  PIECE = 'gab',
}

export function getCountableUnitsByUnit(unit: string, allowedUnits: string[]) {
  let arr: string[] = [];
  switch (unit) {
    case Unit.GRAM:
    case Unit.KILOGRAM:
    case Unit.TON:
      arr = [Unit.GRAM, Unit.KILOGRAM, Unit.TON];
      break;
    case Unit.MILLILITER:
    case Unit.LITER:
      arr = [Unit.MILLILITER, Unit.LITER];
      break;
    case Unit.PIECE:
      arr = [Unit.PIECE];
      break;
  }
  return arr.filter((e) => allowedUnits.includes(e));
}
